import { MetricMeta } from './types';

/**
 * Activity types are ordered by family, then label. The grid shows no family
 * headers, because a header above a single row looks like a mistake. The
 * Definitions dialog does group them.
 */
export const FAMILY_ORDER = ['instruction', 'rituals', 'assessment', 'management'];

export const FAMILY_LABELS: Record<string, string> = {
  instruction: 'Instruction',
  rituals: 'Lesson rituals',
  assessment: 'Assessment',
  management: 'Class management',
};

export function orderByFamily<T extends { family: string; label: string }>(
  items: T[],
): T[] {
  return [...items].sort((a, b) => {
    const familyDelta = FAMILY_ORDER.indexOf(a.family) - FAMILY_ORDER.indexOf(b.family);
    if (familyDelta !== 0) return familyDelta;
    return a.label.localeCompare(b.label);
  });
}

/**
 * Activity types nobody in the view used. Totals come from the server for the
 * whole view, so hiding inactive teachers never changes this. A missing total
 * never counts as unused.
 */
export function unusedMetricSlugs(metrics: MetricMeta[]): Set<string> {
  return new Set(
    metrics.filter((metric) => metric.total === 0).map((metric) => metric.slug),
  );
}
